export default __webpack_public_path__ + "static/media/Back_To_Top.1bfb9f67.svg";